module.exports = __webpack_public_path__ + "img/image-site-mayenne.c04620be.jpg";